export class basicDeliveryUrls {
  delivery = `/apirides.apptunix.com/v2`;
  // ----- Bookings Start -----
  taxiBookings: string = `${this.delivery}/admin/taxi/bookings`;
  // ----- App Setting End -----
}
